import React from "react";
import { FilePreviewBody, FilePreviewHeader } from "../../components/FilePreview";

/* ── Preview Modal Component ──
   Thin shell around the shared preview engine (src/app/components/FilePreview),
   which owns the fetching, file-type detection and rendering. */
export const PreviewModal = React.memo(function PreviewModal({
  url,
  fileName,
  downloadUrl,
  onClose,
}: {
  url: string;
  fileName: string | null;
  downloadUrl: string;
  onClose: () => void;
}) {
  return (
    <div
      className="fixed inset-0 z-50 flex justify-center overflow-y-auto p-4"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div
        className="fixed inset-0 bg-background/80 backdrop-blur-sm"
        onClick={onClose}
      />
      <div className="relative w-full max-w-6xl my-auto h-[860px] max-h-[860px] rounded-xl border border-border bg-card shadow-xl flex flex-col overflow-hidden">
        <FilePreviewHeader
          fileName={fileName}
          downloadUrl={downloadUrl}
          onClose={onClose}
        />
        <FilePreviewBody url={url} fileName={fileName} />
      </div>
    </div>
  );
});
